<!-- Enhanced Report Header with Glass Morphism Effect -->
<div class="report-header bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-900 
            backdrop-blur-sm border-b border-gray-200 dark:border-gray-700 px-6 py-4 rounded-t-lg shadow-sm">
    <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <a 
  [routerLink]="['/main/manage-campaign']" 
  [queryParams]="{ type: 'call' }"
  class="back-icon group flex items-center justify-center w-10 h-10 rounded-full 
         bg-white dark:bg-gray-700 shadow-md hover:shadow-lg transition-all duration-300 
         hover:scale-110 border border-gray-200 dark:border-gray-600">
    <i class="pi pi-arrow-left text-gray-600 dark:text-gray-300 group-hover:text-blue-600 
             dark:group-hover:text-blue-400 transition-colors duration-200"></i>
</a>

            <div class="flex flex-col">
                <h1 class="font-bold text-xl text-gray-900 dark:text-white mb-0">
                    {{ campaignName || 'Call Campaign Details' }}
                </h1>
                <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Comprehensive data overview</p>
            </div>
        </div>
        
        <!-- Action Buttons -->
        <div class="flex items-center space-x-3">
            <!-- Export Button -->
            <button 
                (click)="exportToExcel()"
                [disabled]="loading || dataSource.length === 0"
                class="export-btn group flex items-center justify-center px-4 py-2 rounded-lg 
                       bg-green-600 hover:bg-green-700 text-white shadow-md hover:shadow-lg 
                       transition-all duration-300 hover:scale-105 border border-green-700 
                       disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100">
                <i class="pi pi-file-excel mr-2"></i>
                <span class="text-sm font-medium">Export</span>
            </button>
            
            <!-- Refresh Button -->
            <button 
                (click)="refreshData()"
                [disabled]="loading"
                class="refresh-btn group flex items-center justify-center w-10 h-10 rounded-full 
                       bg-white dark:bg-gray-700 shadow-md hover:shadow-lg transition-all duration-300 
                       hover:scale-110 border border-gray-200 dark:border-gray-600 
                       disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100">
                <i class="pi pi-refresh text-gray-600 dark:text-gray-300 group-hover:text-blue-600 
                         dark:group-hover:text-blue-400 transition-colors duration-200"
                   [class.pi-spin]="loading"></i>
            </button>
        </div>
    </div>
</div>


<div
    class="table-container rounded-[20px] mx-6 mt-4 bg-white dark:bg-gray-800  shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
    <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading"
        [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
         [scrollable]="true"
  scrollHeight="calc(90vh - 140px)"
        >

        <ng-template pTemplate="header">
            <tr>
                <th>S.No</th>
                <th *ngFor="let col of displayedColumns">
                    {{ col.header }}
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-i="rowIndex"  >
            <tr>
                <td>{{ i + 1 }}</td>
                <td *ngFor="let col of displayedColumns">
                    <ng-container [ngSwitch]="col.type">

                        <!-- Name -->
                        <ng-container *ngSwitchCase="'contact_name'">
                            {{ rowData['name'] || 'N/A' }}
                        </ng-container>

                        <!-- Mobile -->
                        <ng-container *ngSwitchCase="'phone'">
                            {{ rowData['mobile_number'] || 'N/A' }}
                        </ng-container>

                        <!-- Email -->
                        <ng-container *ngSwitchCase="'email'">
                            {{ rowData['email'] || 'N/A' }}
                        </ng-container>

                        <!-- Call Status -->
                        <ng-container *ngSwitchCase="'call_status'">
                            <span [class]="'px-2 py-1 rounded-full text-xs font-medium ' + 
                                (rowData['call_status'] === 'just_called' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300' :
                                 rowData['call_status'] === 'failed' ? 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300' :
                                 rowData['call_status'] === 'busy' ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300' :
                                 rowData['call_status'] === 'completed' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300' :
                                 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300')">
                                {{ rowData['call_status'] ? formateStatus(rowData['call_status']) : 'N/A' }}
                            </span>
                        </ng-container>

                        <!-- Call Type -->
                        <ng-container *ngSwitchCase="'call_type'">
                            <span [class]="'px-2 py-1 rounded-full text-xs font-medium ' + 
                                (rowData['call_type'] === 'outbound_call' ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300' :
                                 rowData['call_type'] === 'inbound_call' ? 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300' :
                                 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300')">
                                {{ rowData['call_type'] ? (rowData['call_type'].replace('_', ' ') | titlecase) : 'N/A' }}
                            </span>
                        </ng-container>

                        <!-- Call Action -->
                        <ng-container *ngSwitchCase="'call_action'">
                            <span [class]="'px-2 py-1 rounded-full text-xs font-medium ' + 
                                (rowData['call_action_type'] === 'wrong_respond' ? 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300' :
                                 rowData['call_action_type'] === 'no_response' ? 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300' :
                                 rowData['call_action_type'] === 'interested' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300' :
                                 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300')">
                                {{ rowData['call_action_type'] ? (rowData['call_action_type'].replace('_', ' ') | titlecase) : 'N/A' }}
                            </span>
                        </ng-container>

                        <!-- Call Remarks -->
                        <ng-container *ngSwitchCase="'call_remarks'">
                            <span class="text-sm" [title]="rowData['call_remarks']">
                                {{ rowData['call_remarks'] ? (rowData['call_remarks'].replace('-', ' - ') | titlecase) : 'N/A' }}
                            </span>
                        </ng-container>

                        <!-- Pickup Date -->
                        <ng-container *ngSwitchCase="'pickup_date'">
                            {{ rowData['call_pickup_date'] ? (rowData['call_pickup_date'] | date:'mediumDate') : 'N/A' }}
                        </ng-container>

                        <!-- Pickup Time -->
                        <ng-container *ngSwitchCase="'pickup_time'">
                            {{ rowData['call_pickup_time'] || 'N/A' }}
                        </ng-container>

                        <!-- Attempts -->
                        <ng-container *ngSwitchCase="'attempts'">
                            <span [class]="'px-2 py-1 rounded-full text-xs font-medium ' + 
                                (rowData['num_tries'] > 3 ? 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300' :
                                 rowData['num_tries'] > 1 ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300' :
                                 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300')">
                                {{ rowData['num_tries'] || 0 }}
                            </span>
                        </ng-container>

                        <!-- Follow Up Date -->
                        <ng-container *ngSwitchCase="'follow_up_date'">
                            {{ rowData['follow_up_date'] ? (rowData['follow_up_date'] | date:'mediumDate') : 'N/A' }}
                        </ng-container>

                        <!-- Follow Up Time -->
                        <ng-container *ngSwitchCase="'follow_up_time'">
                            {{ rowData['follow_up_time'] || 'N/A' }}
                        </ng-container>

                        <!-- Course -->
                        <ng-container *ngSwitchCase="'course'">
                            {{ rowData['course'] || 'N/A' }}
                        </ng-container>

                        <!-- Advisor Notes -->
                        <ng-container *ngSwitchCase="'advisor_notes'">
                            <span class="text-sm" [title]="rowData['advisor_guidance']">
                                {{ rowData['advisor_guidance'] ? 
                                    (rowData['advisor_guidance'].length > 30 ? 
                                     rowData['advisor_guidance'].substring(0, 30) + '...' : 
                                     rowData['advisor_guidance']) : 'N/A' }}
                            </span>
                        </ng-container>

                        <!-- Last Updated -->
                        <ng-container *ngSwitchCase="'last_updated'">
                            {{ rowData['last_updated'] ? (formatTimestamp(rowData['last_updated']) | date:'medium') : 'N/A' }}
                        </ng-container>

                        <!-- Created At -->
                        <ng-container *ngSwitchCase="'created_at'">
                            {{ rowData['created_at'] ? (formatTimestamp(rowData['created_at']) | date:'mediumDate') : 'N/A' }}
                        </ng-container>

                        <!-- Default -->
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] || 'N/A' }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="loading">
            <tr>
                <td [attr.colspan]="displayedColumns.length + 1" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="displayedColumns.length + 1" class="no-data-record-found">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>